import { ComponentNotificationBodyTaskTitleAndDescription } from "./types/task-notification.types";
import { TaskNotificationPriority } from "./TaskNotificationPriority";
import { TaskNotificationStatus } from "./TaskNotificationStatus";
import styles from "./task-notification.module.css";
import { TaskNotificationSafety } from "./TaskNotificationSafety";

interface TaskNotificationBodyTitleAndDescriptionProps extends ComponentNotificationBodyTaskTitleAndDescription {
  read: boolean;
}
export const TaskNotificationBodyTitleAndDescription = ({
  props: { priority, safety, status, title, description },
}: TaskNotificationBodyTitleAndDescriptionProps) => {
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {priority && <TaskNotificationPriority />}
        {safety && <TaskNotificationSafety />}
        {!!title && (
          <div className={styles["task-notification-item-body-title"] ?? ""}>
            {title}
          </div>
        )}
        {!!description && <div>{description}</div>}
      </div>
      {(status === "completed" || status === "closed") && (
        <TaskNotificationStatus status={status} />
      )}
    </div>
  );
};
